module.exports = __webpack_public_path__ + "static/media/33.4f1f4909.svg";